import { render, staticRenderFns } from "./commodity-addition.vue?vue&type=template&id=02e31aa5&scoped=true&"
import script from "./commodity-addition.vue?vue&type=script&lang=js&"
export * from "./commodity-addition.vue?vue&type=script&lang=js&"
import style0 from "./commodity-addition.vue?vue&type=style&index=0&id=02e31aa5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e31aa5",
  null
  
)

export default component.exports